import { useEffect, useState } from 'react';

// iOS keyboards resize the visual viewport independently of CSS layout height.
export default function useViewportHeight() {
  const [height, setHeight] = useState('100dvh');
  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return undefined;
    const resize = () => { if (viewport.height > 0 && (!viewport.scale || viewport.scale === 1)) setHeight(`${Math.round(viewport.height)}px`); };
    resize();
    viewport.addEventListener('resize', resize);
    window.addEventListener('orientationchange', resize);
    return () => { viewport.removeEventListener('resize', resize); window.removeEventListener('orientationchange', resize); };
  }, []);
  return height;
}
